"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketLoggingOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketLoggingOutput.js.map